import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { userManager } from "./msalInstance";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "./i18n";
import "./components/PrimeReactDataGrid/PrimeReactDataGridStyle.css";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { PrimeReactProvider } from "primereact/api";

const nonce = window.__CSP_NONCE__;

const primeReactNonce = {
  nonce: nonce,
};

const emotionCache = createCache({
  key: "css",
  nonce,
});

const container = document.getElementById("root");
const root = createRoot(container);

// No async initialize() step needed (unlike MSAL's PublicClientApplication) —
// userManager is already constructed and ready by the time this runs.
root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <AuthProvider userManager={userManager}>
        <PrimeReactProvider value={primeReactNonce}>
          <App />
        </PrimeReactProvider>
      </AuthProvider>
    </CacheProvider>
  </React.StrictMode>,
);

reportWebVitals();
